import {
    ReactElement,
    useMemo,
} from 'react';

import {Stack,} from '@mantine/core';
import {useParams} from 'react-router-dom';

import {useSteps} from '../hooks/useSteps.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useStepsSelection} from '../hooks/useStepsSelection.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useStepsPaging} from "../hooks/useStepsPaging.ts";
import {useStepsSearch} from "../hooks/useStepsSearch.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    // Scope the list query to the current phase (preferred) or playbook, from
    // the route params. IndexPage is always rendered inside a phase route, so
    // phaseId is the expected scope. playbookId is included as a fallback.
    const {id: playbookId, phaseId} = useParams();
    const filters = useMemo<Record<string, string>>(() => {
        const next: Record<string, string> = {};
        if (phaseId) {
            next.phaseId = phaseId;
        } else if (playbookId) {
            next.playbookId = playbookId;
        }
        return next;
    }, [phaseId, playbookId]);

    const {
        columns,
        visibleItems: records,
        loading,
    } = useSteps(filters);

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useStepsPaging();

    const {
        handleFilterByKeyword,
    } = useStepsSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = useStepsSelection();


    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeleteStep)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(id => ({ id }))
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection((item as any).id, true)
                    })
                }}
                fetching={loading}
            />


        </Stack>
    );


};
